var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_637_15045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5691 6.66632V50.1193L32.4061 53.2406V16.7871C32.4061 15.0845 33.1628 13.94 34.3924 14.3373C36.0004 14.7818 36.3125 16.352 36.3125 18.064V32.6208C42.4417 35.5814 47.2656 32.6208 47.2656 24.808C47.2656 16.9951 44.4469 13.2401 36.1139 10.3741C32.8412 9.2769 26.7498 7.44193 22.5691 6.66632Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2582 46.8934L50.0731 41.256C51.8703 40.6128 52.1445 39.7048 50.6879 39.2224C49.2313 38.7495 46.5923 38.8819 44.8047 39.5251L34.2582 43.2423V37.3307L34.8636 37.1226C34.8636 37.1226 37.9093 36.0443 42.1846 35.5714C46.4694 35.1079 51.7094 35.6281 55.8239 37.1983C60.4681 38.6643 60.9884 40.8209 59.806 42.3059C58.6237 43.7909 55.7388 44.8598 55.7388 44.8598L34.2488 52.578V46.8934H34.2582Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52973 46.2989C-0.227959 44.9558 -1.0225 42.1655 1.14353 40.5575C3.15822 39.0725 6.56336 37.9564 6.56336 37.9564L20.6567 32.9528V38.6563L10.5171 42.2884C8.71993 42.9316 8.45506 43.8397 9.90223 44.3126C11.3589 44.795 13.9979 44.6531 15.795 44.0099L20.6567 42.2506V47.3583C20.3446 47.415 20.0041 47.4623 19.692 47.5191C14.8208 48.3136 9.6374 47.9825 4.52973 46.2989Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_637_15045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystation);
export default __webpack_public_path__ + "static/media/playstation.4c23a16bc1619a859548a7007b592b83.svg";
export { ForwardRef as ReactComponent };